import Vue from "vue";

export const TermConditionEventBus = new Vue();
